import Vue from 'vue'
import Router from 'vue-router'
import layOut from "../components/layOut";
import home from "../views/home/index"
import login from "../views/Login/index"
import DataScreen from "../views/RealTimeScheduling/DataScreen/index"
Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'layOut',
      component: layOut,
      redirect: { name: 'home' },
      children: [
        {
          path: 'home',
          name: 'home',
          component: home,
        },
        {
          path: 'videoSurveillance',
          name: 'VideoSurveillance',
          component: () => import("@/views/VideoLive/VideoSurveillance/index")
        },
        {
          path: 'videoTablePage',
          name: 'VideoTablePage',
          component: () => import("@/views/VideoLive/components/LayOut"),
          redirect: { name: 'DataExamine' },
          children: [
            {
              path: 'dataExamine',
              name: 'DataExamine',
              component: () => import("@/views/VideoLive/DataExamine/index"),
              meta: { title: '数据审核' }
            },
            {
              path: 'videoManage',
              name: 'VideoManage',
              component: () => import("@/views/VideoLive/VideoManage/index"),
              meta: { title: '点位管理' }
            }
          ]
        },
        {
          path: 'set',
          name: 'Set',
          component: () => import("@/views/Set/index"),
          redirect: { name: 'User' },
          children: [
            {
              path: 'user',
              name: 'User',
              component: () => import("@/views/Set/User/index"),
              meta: { title: '后台管理' }
            }
          ]
        },
        {
          path: 'comprehensive',
          name: 'Comprehensive',
          component: () => import("@/views/Comprehensive/index"),
          redirect: { name: 'WarningManage' },
          children: [
            {
              path: 'warningManage',
              name: 'WarningManage',
              component: () => import("@/views/Comprehensive/warningManage/index"),
              meta: { title: '报警管理' }
            }
          ]
        },
        {
          path: '/realTimeScheduling',
          name: 'RealTimeScheduling',
          component: () => import("@/views/RealTimeScheduling/index"),
          redirect: { name: 'DataScreen' },
          children: [
            {
              path: 'dataScreen',
              name: 'DataScreen',
              component: DataScreen,
              meta: { title: '数据大屏' }
            }
          ]
        },
        {
          path: '/dataCenter',
          name: 'DataCenter',
          component: () => import("@/views/DataCenter/index"),
          redirect: { name: 'DataScreen' },
          children: [
            {
              path: 'historicalRanking',
              name: 'HistoricalRanking',
              component: () => import("@/views/DataCenter/HistoricalRanking/index"),
              meta: { title: '历史排名' }
            },
            {
              path: 'historicalData',
              name: 'HistoricalData',
              component: () => import("@/views/DataCenter/HistoricalData/index"),
              meta: { title: '历史数据' }
            },
            {
              path: 'dataAnalysis',
              name: 'DataAnalysis',
              component: () => import("@/views/DataCenter/DataAnalysis/index"),
              meta: { title: '数据分析' }
            },
            {
              path: 'associationMining',
              name: 'AssociationMining',
              component: () => import("@/views/DataCenter/AssociationMining/index"),
              meta: { title: '关联挖掘' }
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: "/404",
      name: "/404",
      component: () => import("@/views/404.vue"),
      meta: {title: "404"}
    },
    {
      path: "/403",
      name: "/403",
      component: () => import("@/views/403.vue"),
      meta: {title: "403"}
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
})
